export default __webpack_public_path__ + "static/tecalis-students_01-128601c998e97c035721f9ad61d76a09.png";